import * as gameboardActions from '../../actions/earlyGameboard'
import { RATE_PATHWAY } from '../../actions/pathwayProfile'
import { RATE_OCCUPATION } from '../../actions/early/occupationProfile'
import { RATE_TOOL } from '../../actions/early/tools'
import * as earlyListingActions from '../../actions/early/earlyListing'
import * as h2Api from '../../h2Api'
import { API_LEVEL_SET } from '../../actions/earlyGameboard'

const initialState = {
  selectedTab: 1,
  notes: [],
  ratings: {
    pathways: [],
    occupations: [],
    tools: []
  }
}
const earlyBackpack = (state = initialState, action) => {
  switch (action.type) {
    case gameboardActions.CLICK_BACKPACK_TAB:
      return {
        ...state,
        selectedTab: action.tabId
      }

    case gameboardActions.API_LEVEL_SET:
      return {
        ...state,
        reflections: [
          ...state.reflections,
          {
            id: `lvl-${action.details.levelId}`,
            type: 'reflection',
            dateEntered: new Date().toISOString(),
            note: action.details.levelReflection,
            levelEntered: action.details.levelId
          }
        ]
      }

    case earlyListingActions.LOAD_GAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const combine = (levelDate, levelNote, levelEntered) => {
          if (levelNote) {
            return {
              id: `lvl-${levelEntered}`,
              type: 'reflection',
              dateEntered: levelDate,
              note: levelNote,
              levelEntered
            }
          }
        }

        return {
          ...state,
          notes: action.restCall.result.notes,
          reflections: [
            combine(
              action.restCall.result.level1CompletionDate,
              action.restCall.result.level1CompletionNotes,
              1
            ),
            combine(
              action.restCall.result.level2CompletionDate,
              action.restCall.result.level2CompletionNotes,
              2
            ),
            combine(
              action.restCall.result.level3CompletionDate,
              action.restCall.result.level3CompletionNotes,
              3
            ),
            combine(
              action.restCall.result.level4CompletionDate,
              action.restCall.result.level4CompletionNotes,
              4
            ),
            combine(
              action.restCall.result.level5CompletionDate,
              action.restCall.result.level5CompletionNotes,
              5
            )
          ].filter(refl => refl),
          ratings: {
            ...state.ratings,
            pathways: action.restCall.result.ratings
              .filter(r => r.objectType === 'pathway')
              .map(p => ({
                pathwayId: p.objectId,
                rating: p.rating
              })),
            occupations: action.restCall.result.ratings
              .filter(r => r.objectType === 'occupation')
              .map(p => ({
                onetSoc: p.objectId,
                rating: p.rating
              })),
            tools: action.restCall.result.ratings
              .filter(r => r.objectType === 'tool')
              .map(p => ({
                toolId: p.objectId,
                rating: p.rating
              }))
          }
        }
      }

      return state

    case RATE_PATHWAY:
      const contains = state.ratings.pathways.filter(
        p => p.pathwayId !== action.pathway.id
      )

      return {
        ...state,
        ratings: {
          ...state.ratings,
          pathways: [
            ...contains,
            {
              pathwayId: action.pathway.id,
              rating: action.rating
            }
          ]
        }
      }

    case RATE_TOOL:
      const containsTool = state.ratings.tools.filter(p => p.toolId !== action.toolId)

      return {
        ...state,
        ratings: {
          ...state.ratings,
          tools: [
            ...containsTool,
            {
              toolId: action.toolId,
              rating: action.rating
            }
          ]
        }
      }

    case RATE_OCCUPATION:
      const containsOcc = state.ratings.occupations.filter(
        p => p.onetSoc !== action.occupation.onetSoc
      )

      return {
        ...state,
        ratings: {
          ...state.ratings,
          occupations: [
            ...containsOcc,
            {
              onetSoc: action.occupation.onetSoc,
              rating: action.rating
            }
          ]
        }
      }

    case earlyListingActions.LOAD_GAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          notes: action.restCall.result.notes
        }
      }

      return state

    case gameboardActions.UPDATE_NOTES:
      return {
        ...state,
        notes: action.notes
      }

    case gameboardActions.SAVE_NOTES_INITAL:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          notes: [...state.notes, action.restCall.result]
        }
      }

      return state

    case gameboardActions.SAVE_NOTES_UPDATE:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log('NOTE', action.note, action.noteId, action.restCall.result)

        return {
          ...state,
          notes: [
            ...state.notes.filter(n => n.id != action.noteId),
            action.restCall.result
          ]
        }
      }

      return state

    default:
      return state
  }
}

export default earlyBackpack
